import { render } from "./ordercarousel.vue?vue&type=template&id=630ea011&scoped=true"
import script from "./ordercarousel.vue?vue&type=script&lang=js"
export * from "./ordercarousel.vue?vue&type=script&lang=js"

import "./ordercarousel.vue?vue&type=style&index=0&id=630ea011&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-630ea011"]])

export default __exports__